import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";
import { ILocation } from "../../../../../.MODULS/BOOKLET_ADMIN_MODUL/Master/Center/ICenter";

export const CentreMasterLocationSlice = createSlice({
  name: "CentreMasterLocationSlice",
  initialState: {} as IReduxState<ILocation>,
  reducers: {
    CentreMasterLocation: (state) => {
      state.isLoading = true;
    },
    successCentreMasterLocation: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureCentreMasterLocation: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearCentreMasterLocation: (state) => {
      state.data = {};
    },
  },
});

export const {
  CentreMasterLocation,
  successCentreMasterLocation,
  failureCentreMasterLocation,
  clearCentreMasterLocation,
} = CentreMasterLocationSlice.actions;

export default CentreMasterLocationSlice.reducer;
